<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!-- <CIcon name="logo" height="48" alt="Logo"/> -->
    </CHeaderBrand>
    <CHeaderNav class="d-sm-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/commerceInventory">
          <img src="img/banner_header.png" class="c-avatar-img" /> {{ name }}
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <TheHeaderDropdownBadge/>
      <TheHeaderDropdownCart/>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownCart from './TheHeaderDropdownCart'
import TheHeaderDropdownBadge from './TheHeaderDropdownBadge'
import TheHeaderDropdownNotification from './TheHeaderDropdownNotification'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownCart,
    TheHeaderDropdownBadge,
    TheHeaderDropdownNotification,
  },
  data(){
    return {
      name: '',
    };
  },
  mounted() {
    this.name = this.$store.state.user.name;
  },
}
</script>
